// Approved premium packaging (owner reference). Contents marked
// 'supplier-pending' must be confirmed before publication.

export type PackagingItem = {
  item: string;
  status: 'owner-approved' | 'supplier-pending';
};

export const packagingDesign: string[] = [
  'Deep navy exterior',
  'Metallic silver nautical crest',
  'Premium wave graphics',
  'Refined typography',
  'Black precision-cut interior',
];

/** Customer-facing box contents per light — confirmed items only. */
export const boxContents: string[] = [
  'M1 PRO Wireless RGB Light — 13 LEDs',
  'Magnetic Mount System base',
  'Remote control (2 AAA batteries, not included)',
];

export const packagingContents: PackagingItem[] = [
  { item: 'M1 PRO Wireless RGB Light — 13 LED lenses', status: 'owner-approved' },
  { item: 'White matched-diameter base labeled “MAGNETIC MOUNT SYSTEM”', status: 'owner-approved' },
  { item: 'USB-C charging cable', status: 'supplier-pending' },
  { item: 'Approved installation accessories', status: 'supplier-pending' },
  { item: 'Quick-start guide', status: 'supplier-pending' },
];
